import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { i18n } from "services/i18nService";
import { linkUpsAccount } from "services/sosInventoryService/sosApi";

import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

import { UPS_AUTH_REDIRECT_URL } from "appConstants";

const DEFAULT_LINK_ERROR = i18n("error.ErrorLinkingUpsAccount");

export function UpsAuth() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    function handleError(authError) {
      navigate("/configuration/connections/ups", { state: { authError } });
    }
    async function _linkUpsAccount(params) {
      dispatch(loadingIndicatorOn());
      try {
        const { success, message } = await linkUpsAccount(params);
        if (success) {
          navigate("/configuration/connections/ups");
        } else {
          handleError(message || DEFAULT_LINK_ERROR);
        }
        dispatch(loadingIndicatorOff());
      } catch (e) {
        dispatch(loadingIndicatorOff());
        handleError(DEFAULT_LINK_ERROR);
      }
    }

    const queryParams = new URLSearchParams(search);
    const localState = localStorage.getItem("upsState");
    const state = queryParams.get("state");
    const code = queryParams.get("code");

    if (state !== localState) {
      handleError(DEFAULT_LINK_ERROR);
    } else if (code) {
      _linkUpsAccount({ code, state, redirect: UPS_AUTH_REDIRECT_URL });
    } else {
      handleError(DEFAULT_LINK_ERROR);
    }
  }, [navigate, search, dispatch]);

  return null;
}
